var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPillboxClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "7px",
    viewBox: "0 0 9 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forms",
    transform: "translate(-2362.000000, -1763.000000)",
    stroke: "#323E48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(2361.000000, 1223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_pillbox_close",
    transform: "translate(0.000000, 513.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(2.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.233345,0.2333345 L6.76667822,6.76666772",
    id: "Stroke-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76667822,0.2333345 L0.233345,6.76666772",
    id: "Stroke-7"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPillboxClose);
export default __webpack_public_path__ + "static/media/icon_pillbox_close.c2fb55b1.svg";
export { ForwardRef as ReactComponent };